import './Styles/index.scss';

import './Scripts/global';

import 'bootstrap';
import 'datatables.net';
import 'datatables.net-bs5';
import 'datatables.net-responsive';
import 'datatables.net-responsive-bs5';
import 'datatables.net-select';
import 'datatables.net-select-bs5';
import 'moment';
import 'moment/locale/de';
import 'handlebars';
import 'sifter';
import 'microplugin';
import '@selectize/selectize';

import './Scripts';
